module.exports = __webpack_public_path__ + "img/mining_big.58aa0f20.png";